module.exports = __webpack_public_path__ + "static/media/2.93ecf196.JPG";